import { AfterViewChecked, Component, ViewChild } from '@angular/core';
import { HelpersService } from '../../services/helpers.service';
declare let require: any;

@Component({ standalone: false,
  selector: 'vfa-cp-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements AfterViewChecked {
  public appVersion = require('../../../../../../package.json').version;

  constructor(public helpersService: HelpersService) {}
  private impressumListenerAdded: boolean = false;

  ngAfterViewChecked() {
    if(!this.impressumListenerAdded) {
      this.helpersService.eventToImpressum();
      this.impressumListenerAdded = true;
    }
  }
}

